import React, { useContext, useState } from 'react'
import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import SelectImgComp from '../../../../MySections/ImagesSetter/SelectImgComp';

const daysOfWeek = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];

const emptyOpeningHours = () => daysOfWeek.map((Day) => ({ Day, Open: "", Close: "" }));

const SEOs = (props) => {
    const [theMaster] = useContext(TheMasterContext);

    const [sEOdescription, setSEOdescription] = useState(theMaster.sEOdescription);
    const [sEOkeywords, setSEOkeywords] = useState(theMaster.sEOkeywords);

    const [seoBusinessName, setSeoBusinessName] = useState(theMaster.seoBusinessName);
    const [seoH1, setSeoH1] = useState(theMaster.seoH1);
    const [seoCategory, setSeoCategory] = useState(theMaster.seoCategory);
    const [seoPriceRange, setSeoPriceRange] = useState(theMaster.seoPriceRange);

    const [seoAddressStreet, setSeoAddressStreet] = useState(theMaster.seoAddressStreet);
    const [seoAddressCity, setSeoAddressCity] = useState(theMaster.seoAddressCity);
    const [seoAddressZip, setSeoAddressZip] = useState(theMaster.seoAddressZip);
    const [seoPhone, setSeoPhone] = useState(theMaster.seoPhone);
    const [seoEmail, setSeoEmail] = useState(theMaster.seoEmail);
    const [seoOpeningHours, setSeoOpeningHours] = useState(
        theMaster.seoOpeningHours && theMaster.seoOpeningHours.length > 0
            ? theMaster.seoOpeningHours
            : emptyOpeningHours()
    );

    const [seoImage, setSeoImage] = useState(theMaster.seoImage);

    const [seoFacebookUrl, setSeoFacebookUrl] = useState(theMaster.seoFacebookUrl);
    const [seoInstagramUrl, setSeoInstagramUrl] = useState(theMaster.seoInstagramUrl);
    const [seoGoogleMapsUrl, setSeoGoogleMapsUrl] = useState(theMaster.seoGoogleMapsUrl);

    const setField = (key, value, setter) => {
        theMaster[key] = value;
        setter(value);
    }

    const setOpeningHour = (index, key, value) => {
        const updated = [...seoOpeningHours];
        updated[index] = { ...updated[index], [key]: value };
        theMaster["seoOpeningHours"] = updated;
        setSeoOpeningHours(updated);
    }

    return (
        <>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_99"}>קידום SEO</label>
                <span className={"explanation mediumst fullROw"}>
                    כל השדות במקום אחד, המשמשים לבניית מידע מובנה (Schema.org) עבור מנועי חיפוש.
                </span>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>זהות עסקית</label>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"seoBusinessName"}>שם עסק רשמי</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoBusinessName"} placeholder={"לדוגמה: לולה אשדוד"} value={seoBusinessName || ""}
                        onChange={(e) => setField("seoBusinessName", e.target.value, setSeoBusinessName)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"seoH1"}>כותרת ראשית (H1)</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoH1"} placeholder={"כותרת ממוקדת מילת מפתח, לדוגמה: לולה אשדוד - מסעדה ומשלוחים"} value={seoH1 || ""}
                        onChange={(e) => setField("seoH1", e.target.value, setSeoH1)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"seoCategory"}>סוג מטבח / קטגוריה</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoCategory"} placeholder={"לדוגמה: איטלקי, ים תיכוני"} value={seoCategory || ""}
                        onChange={(e) => setField("seoCategory", e.target.value, setSeoCategory)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"seoPriceRange"}>טווח מחירים</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoPriceRange"} placeholder={"לדוגמה: 50-150"} value={seoPriceRange || ""}
                        onChange={(e) => setField("seoPriceRange", e.target.value, setSeoPriceRange)} />
                </div>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>מיקום ויצירת קשר</label>
            </div>
            <div className={"col-md-8 mb-2"}>
                <label htmlFor={"seoAddressStreet"}>כתובת (רחוב ומספר)</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoAddressStreet"} placeholder={"לדוגמה: הרצל סמואל 12"} value={seoAddressStreet || ""}
                        onChange={(e) => setField("seoAddressStreet", e.target.value, setSeoAddressStreet)} />
                </div>
            </div>
            <div className={"col-md-4 mb-2"}>
                <label htmlFor={"seoAddressCity"}>עיר</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoAddressCity"} placeholder={"אשדוד"} value={seoAddressCity || ""}
                        onChange={(e) => setField("seoAddressCity", e.target.value, setSeoAddressCity)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"seoAddressZip"}>מיקוד (אופציונלי)</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoAddressZip"} value={seoAddressZip || ""}
                        onChange={(e) => setField("seoAddressZip", e.target.value, setSeoAddressZip)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}></div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"seoPhone"}>טלפון</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoPhone"} placeholder={"050-0000000"} value={seoPhone || ""}
                        onChange={(e) => setField("seoPhone", e.target.value, setSeoPhone)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"seoEmail"}>אימייל (אופציונלי)</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoEmail"} value={seoEmail || ""}
                        onChange={(e) => setField("seoEmail", e.target.value, setSeoEmail)} />
                </div>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>שעות פתיחה</label>
                <table className={"tabTable tableBordSpace"}>
                    <tbody>
                        {seoOpeningHours.map((item, index) => (
                            <tr key={item.Day}>
                                <td style={{ width: "15%" }} className={"centerText"}>{item.Day}</td>
                                <td>
                                    <input type={"text"} className={"form-control"} placeholder={"פתיחה, לדוגמה 10:00"} value={item.Open || ""}
                                        onChange={(e) => setOpeningHour(index, "Open", e.target.value)} />
                                </td>
                                <td>
                                    <input type={"text"} className={"form-control"} placeholder={"סגירה, לדוגמה 22:00"} value={item.Close || ""}
                                        onChange={(e) => setOpeningHour(index, "Close", e.target.value)} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>מדיה</label>
            </div>
            <div className={"col-md-3 mb-2"}>
                <label htmlFor={"seoImage"}>תמונה ראשית לייצוג העסק</label>
                <span className={"explanation mediumst fullROw"}>מומלץ תמונה אמיתית של המקום/מנה ולא לוגו - גוגל מעדיף זאת בתצוגה מקדימה.</span>
                <SelectImgComp
                    firstImgToDisp={seoImage ? seoImage : ""}
                    theFunction={(fUrl) => setField("seoImage", fUrl, setSeoImage)} />
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>רשתות חברתיות</label>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"seoFacebookUrl"}>קישור לפייסבוק</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoFacebookUrl"} value={seoFacebookUrl || ""}
                        onChange={(e) => setField("seoFacebookUrl", e.target.value, setSeoFacebookUrl)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"seoInstagramUrl"}>קישור לאינסטגרם</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoInstagramUrl"} value={seoInstagramUrl || ""}
                        onChange={(e) => setField("seoInstagramUrl", e.target.value, setSeoInstagramUrl)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"seoGoogleMapsUrl"}>קישור לגוגל מפות</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"seoGoogleMapsUrl"} value={seoGoogleMapsUrl || ""}
                        onChange={(e) => setField("seoGoogleMapsUrl", e.target.value, setSeoGoogleMapsUrl)} />
                </div>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label>SEO כללי (ברירת מחדל לעמודים ללא תיאור משלהם)</label>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom02"}>description</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"SEO"} value={sEOdescription || ""}
                        onChange={(e) => setField("sEOdescription", e.target.value, setSEOdescription)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom03"}>keywords</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"validationCustom03"} placeholder={"SEO KEYS"} value={sEOkeywords || ""}
                        onChange={(e) => setField("sEOkeywords", e.target.value, setSEOkeywords)} />
                </div>
            </div>
        </>
    );
}

export default SEOs;
